import PropTypes from 'prop-types';
import ContactType from './contactType';
import SchoolYearType from './schoolYearType';

const BillingContactType = PropTypes.shape({
  id: PropTypes.string,
  billing_payers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    payer_contact: PropTypes.shape({
      id: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string
    })
  })),
  contact: ContactType,
  payment_plan_name: PropTypes.string,
  school_year: SchoolYearType,
  errors: PropTypes.object
});

export default BillingContactType;
